"use strict";
/**
 * Note: The below data is originated from Adyen's payment card types
 *
 * For reference, all the possible values can be found at https://docs.adyen.com/development-resources/paymentmethodvariant
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_CARD_TYPES_MAPPING = exports.EFTPOS_CHEQUE_TYPES = exports.EFTPOS_SAVING_TYPES = exports.AMEX_TYPES = exports.MASTERCARD_TYPES = exports.VISA_TYPES = exports.MASTERCARD_CREDIT_TYPES = exports.MASTERCARD_DEBIT_TYPES = exports.VISA_CREDIT_TYPES = exports.VISA_DEBIT_TYPES = void 0;
const payments_1 = require("../enums/payments");
exports.VISA_DEBIT_TYPES = [
    'visacommercialdebit',
    'visacommercialpremiumdebit',
    'visacommercialsuperpremiumdebit',
    'visacorporatedebit',
    'visadebit',
    'visafleetdebit',
    'visapremiumdebit',
    'visapurchasingdebit',
    'visastandarddebit',
    'visasuperpremiumdebit',
];
exports.VISA_CREDIT_TYPES = [
    'visacommercialcredit',
    'visacommercialpremiumcredit',
    'visacommercialsuperpremiumcredit',
    'visacorporatecredit',
    'visacredit',
    'visafleetcredit',
    'visapremiumcredit',
    'visapurchasingcredit',
    'visastandardcredit',
    'visasuperpremiumcredit',
];
exports.MASTERCARD_DEBIT_TYPES = [
    'mccommercialdebit',
    'mccommercialpremiumdebit',
    'mccorporatedebit',
    'mcdebit',
    'mcfleetdebit',
    'mcpremiumdebit',
    'mcpurchasingdebit',
    'mcstandarddebit',
    'mcsuperpremiumdebit',
];
exports.MASTERCARD_CREDIT_TYPES = [
    'mccommercialcredit',
    'mccommercialpremiumcredit',
    'mccorporatecredit',
    'mccredit',
    'mcfleetcredit',
    'mcpremiumcredit',
    'mcpurchasingcredit',
    'mcstandardcredit',
    'mcsuperpremiumcredit',
];
exports.VISA_TYPES = [
    'visa',
    'visacorporate',
    'visagold',
    'visahipotecario',
    'visaplatinum',
    'visaprepaidanonymous',
    'visaproprietary',
    'visapurchasing',
    'visasaraivacard',
    'visasignature',
];
exports.MASTERCARD_TYPES = [
    'mc',
    'mccorporate',
    'mcpro',
    'mcprepaidanonymous',
];
exports.AMEX_TYPES = ['amex'];
exports.EFTPOS_SAVING_TYPES = ['eftpos_australia_sav'];
exports.EFTPOS_CHEQUE_TYPES = ['eftpos_australia_chq'];
exports.PAYMENT_CARD_TYPES_MAPPING = {
    ...exports.VISA_TYPES.reduce((acc, curr) => ({
        ...acc,
        [curr]: payments_1.PaymentCardTypes.VISA,
    }), {}),
    ...exports.MASTERCARD_TYPES.reduce((acc, curr) => ({
        ...acc,
        [curr]: payments_1.PaymentCardTypes.MASTERCARD,
    }), {}),
    ...exports.VISA_DEBIT_TYPES.reduce((acc, curr) => ({
        ...acc,
        [curr]: payments_1.PaymentCardTypes.VISA_DEBIT,
    }), {}),
    ...exports.VISA_CREDIT_TYPES.reduce((acc, curr) => ({
        ...acc,
        [curr]: payments_1.PaymentCardTypes.VISA_CREDIT,
    }), {}),
    ...exports.MASTERCARD_DEBIT_TYPES.reduce((acc, curr) => ({
        ...acc,
        [curr]: payments_1.PaymentCardTypes.MASTERCARD_DEBIT,
    }), {}),
    ...exports.MASTERCARD_CREDIT_TYPES.reduce((acc, curr) => ({
        ...acc,
        [curr]: payments_1.PaymentCardTypes.MASTERCARD_CREDIT,
    }), {}),
    ...exports.AMEX_TYPES.reduce((acc, curr) => ({
        ...acc,
        [curr]: payments_1.PaymentCardTypes.AMERICAN_EXPRESS,
    }), {}),
    ...exports.EFTPOS_CHEQUE_TYPES.reduce((acc, curr) => ({
        ...acc,
        [curr]: payments_1.PaymentCardTypes.EFTPOS_CHQ,
    }), {}),
    ...exports.EFTPOS_SAVING_TYPES.reduce((acc, curr) => ({
        ...acc,
        [curr]: payments_1.PaymentCardTypes.EFTPOS_SAVING,
    }), {}),
};
//# sourceMappingURL=payments.js.map